module.exports = __webpack_public_path__ + "img/color1-login.9eee7a49.png";